import type { NavItem } from '@/types';

export const mainNavigation: NavItem[] = [
  {
    label: 'Home',
    href: '/'
  },
  {
    label: 'Products',
    href: '/products',
    children: [
      {
        label: 'Handheld Acoustic Imagers',
        href: '/products/handheld',
        children: [
          { label: 'DES-C136', href: '/products/handheld/des-c136' },
          { label: 'DES-T163Pad', href: '/products/handheld/des-t163pad' },
          { label: 'DES-C200', href: '/products/handheld/des-c200' }
        ]
      },
        {
        label: 'Smartphone Acoustic Imager',
        href: '/products/Smartphone-Acoustic-Imager',
        children: [
             { label: 'SoundPin M72/M140', href: '/products/Smartphone-Acoustic-Imager/M72-M140' }
        ]
      },
        {
        label: 'Acoustic Camera Modules',
        href: '/products/modules',
        children: [
          { label: 'PCB Modules', href: '/products/modules/pcb-modules' },
          { label: 'O72 / O140 Core', href: '/products/modules/core-o72-o140' },
          { label: 'F72 / F140 Series', href: '/products/modules/f-series-f72-f140' }
        ]
      },
      {
        label: 'Fixed-mount Systems',
        href: '/products/fixed',
        children: [
          { label: 'DES-T168TPT', href: '/products/fixed/des-t168tpt' }
        ]
      },
    
      {
        label: 'Acoustic Cameras',
        href: '/products/cameras',
        children: [
          { label: 'T144', href: '/products/cameras/t144' },
          { label: 'High Performance Array', href: '/products/cameras/high-performance-array' }
        ]
      },
      {
        label: 'Data Acquisition',
        href: '/products/daq',
        children: [
          { label: 'USB-4228', href: '/products/daq/usb-4228' },
          { label: 'KeyDAQ-8116', href: '/products/daq/keydaq-8116' }
        ]
      },
      {
        label: 'NVH Software',
        href: '/products/nvh-software',
        children: [
          { label: 'SignalPad', href: '/products/nvh-software/signalpad' }
        ]
      },
      {
        label: 'Traffic Monitoring',
        href: '/products/traffic-monitoring',
        children: [
          { label: 'Horn Capture System', href: '/products/traffic-monitoring/horn-capture' },
          { label: 'Revved Vehicle Capture', href: '/products/traffic-monitoring/revved-vehicle-capture' }
        ]
      }
    
    ]
  },
  {
    label: 'Applications',
    href: '/applications',
    children: [
      { label: 'Partial Discharge Detection', href: '/applications/partial-discharge' },
      { label: 'Gas Leak Detection', href: '/applications/gas-leak-detection' },
      { label: 'Traffic Noise Monitoring', href: '/applications/traffic-noise-monitoring' },
      { label: 'NVH Testing', href: '/applications/nvh-testing' }
    ]
  },
  {
    label: 'Support',
    href: '/support',
    children: [
      // { label: 'Downloads', href: '/support/downloads' },
      { label: 'FAQ', href: '/support/faq' }
    ]
  },
  {
    label: 'About',
    href: '/about'
  },
  {
    label: 'Contact',
    href: '/contact'
  }
];

export const footerNavigation = {
  company: [
    { label: 'About Us', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Careers', href: '/about#careers' },
    { label: 'News', href: '/about#news' }
  ],
  products: [
    { label: 'Handheld Imagers', href: '/products/handheld' },
    { label: 'Fixed Systems', href: '/products/fixed' },
    { label: 'Modules', href: '/products/modules' },
    { label: 'Acoustic Cameras', href: '/products/cameras' },
    { label: 'DAQ Systems', href: '/products/daq' },
    { label: 'NVH Software', href: '/products/nvh-software' }
  ],
  applications: [
    { label: 'Partial Discharge', href: '/applications/partial-discharge' },
    { label: 'Gas Leak Detection', href: '/applications/gas-leak-detection' },
    { label: 'Traffic Monitoring', href: '/applications/traffic-noise-monitoring' },
    { label: 'NVH Testing', href: '/applications/nvh-testing' }
  ],
  support: [
    // { label: 'Downloads', href: '/support/downloads' },
    { label: 'FAQ', href: '/support/faq' },
    //{ label: 'Technical Support', href: '/contact#support' },
    //{ label: 'Request Quote', href: '/contact#quote' }
  ]
};

export const productCategoriesNav = [
  { id: 'handheld', name: 'Handheld Acoustic Imagers', href: '/products/handheld' },
  { id: 'fixed', name: 'Fixed-mount Systems', href: '/products/fixed' },
  { id: 'modules', name: 'Acoustic Camera Modules', href: '/products/modules' },
  { id: 'cameras', name: 'Acoustic Cameras', href: '/products/cameras' },
  { id: 'daq', name: 'Data Acquisition', href: '/products/daq' },
  { id: 'nvh-software', name: 'NVH Software', href: '/products/nvh-software' },
  { id: 'traffic-monitoring', name: 'Traffic Monitoring', href: '/products/traffic-monitoring' }
];
